let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("dJjs8")).then(() => parcelRequire('8Ya0K'));